import React, { Component } from "react";
import swal from "sweetalert2";
import {
  ChildLabels,
  ParentDetailsContainer,
  ChildProfileContainer,
  ParentInfo,
  ChildSubHeading,
  ChildFieldLabel,
  ChildInputField,
  InterestsContainer,
  ChildUploadContainer,
  AddButton,
} from "./ChildProfileInfo.styled";
import { SectionHeading } from "@c/activity-view/activity-creator/activity-info/ActivityInfo.styled";
import {
  AlignRow,
  EditIcon,
  ParentBodyContentContainer,
  ParentFormField,
} from "@c/users-view/parent-profile/ParentProfile.styled";
import { FlexBetween, ThemeButton, FlexStart } from "@sc/custom.styled";
import { connectStore } from "redux-box";
import {
  NavigationHeaderContainer,
  NavigationContainer,
} from "@sc/NavigationBar.styled";
import { module as user } from "@st/user";
import ChildSubscription from "@c/users-view/child-profile/child-subscription/ChildSubscription";
import Permission from "@s/permission";
import { module as onboard } from "@st/onboard";
import { module as ui } from "@st/ui";
import {
  ACADEMIC_YEAR_END,
  ACADEMIC_YEAR_START,
  CAMBRIDGE_SCHOOLS,
  IRO_GRADES,
} from "../../../../utils/constant";

class ChildProfileInfo extends Component {
  constructor() {
    super();
    this.state = {
      freados: 0,
      streak: 0,
      freadoAdd: "",
      streakAdd: "",
      enableEdit: false,
      enableToggle: false,
      editFreados: false,
      editStreak: false,
      editCmsId: false,
      selected_nav: "Profile",
      child_info: {
        name: "",
        school: "",
        age: "",
      },
      childBaselineStatus: undefined,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user.active_child !== this.props.user.active_child) {
      if (
        this.props.user.active_child &&
        IRO_GRADES.includes(this.props.user.active_child.grade.name) &&
        this.props.user.active_child.parent &&
        this.props.user.active_child.parent.is_teacher === null
      ) {
        let child = this.props.user.active_child;
        if (
          child.school_code &&
          child.grade &&
          child.grade.name &&
          child.section &&
          child.section.name
        )
          this.props.user.getChildBaselineStatus([
            child.school_code,
            child.grade.name,
            child.section.name,
          ]);
      }
    }

    if (
      prevProps.user.childrenBaselineStatus !==
      this.props.user.childrenBaselineStatus
    ) {

      if (this.props.user.childrenBaselineStatus) {
        let childBaselineStatus = this.props.user.childrenBaselineStatus[
          this.props.user.active_child.id
        ] ? this.props.user.childrenBaselineStatus[
        this.props.user.active_child.id
        ]['Baseline Assessment'] : null;
        console.log(childBaselineStatus);
        this.setState({ childBaselineStatus: childBaselineStatus });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user && nextProps.user.active_child) {
      if (
        this.state.editCmsId &&
        String(nextProps.user.active_child.cms_id || "") === String(this.state.child_info.cms_id || "")
      ) {
        this.setState({ editCmsId: false, isSubmittingCmsId: false });
      } else {
        this.setState({ isSubmittingCmsId: false });
      }
      this.normalizeForState(nextProps.user.active_child);
    } else {
      this.setState({
        freados: 0,
        streak: 0,
        isSubmittingCmsId: false,
        child_info: {
          ...this.state.child_info,
          id: "",
          name: "",
          age: "",
          school: "",
        },
      });
    }
  }

  normalizeForState = (childInfo) => {
    this.setState({
      freados: childInfo.freadom_point,
      streak: childInfo.streak,
      child_info: {
        ...this.state.child_info,

        name: childInfo.name,
        id: childInfo.id,
        school: childInfo.school,
        age: childInfo.age,
        cms_id: childInfo.cms_id || "",
      },
    });
  };

  handleNameChange = (evt) => {
    this.setState({
      child_info: { ...this.state.child_info, name: evt.target.value || "" },
    });
  };

  handleSchoolChange = (evt) => {
    this.setState({
      child_info: { ...this.state.child_info, school: evt.target.value || "" },
    });
  };
  handleAgeChange = (evt) => {
    this.setState({
      child_info: { ...this.state.child_info, age: evt.target.value || "" },
    });
  };
  handleCmsIdChange = (evt) => {
    this.setState({
      child_info: { ...this.state.child_info, cms_id: evt.target.value || "" },
    });
  };

  toggleEditCmsId = () => {
    this.setState({ editCmsId: true });
  };

  handleCmsIdBlurOrSubmit = () => {
    if (this.state.isSubmittingCmsId) return;
    const { cms_id } = this.state.child_info;

    if (
      this.props.user.active_child &&
      String(this.props.user.active_child.cms_id || "").trim() === String(cms_id || "").trim()
    ) {
      this.setState({ editCmsId: false });
      return;
    }

    if (cms_id && !/^\d{1,11}$/.test(cms_id.trim())) {
      swal("Error!", "CMS ID must be up to 11 numeric digits!", "error");
      return;
    }
    if (this.props.user.active_child) {
      this.setState({ isSubmittingCmsId: true });
      this.props.user.requestUpdateChildProfile({
        id: this.props.user.active_child.id,
        cms_id: cms_id ? cms_id.trim() : "",
      });
    }
  };

  handleCmsIdKeyDown = (evt) => {
    if (evt.keyCode === 13) {
      evt.target.blur();
    }
  };

  enableEdit = () => {
    this.setState({
      enableEdit: !this.state.enableEdit,
    });
  };

  handleFreadosChange = (evt) => {
    this.setState({
      freadoAdd: evt.target.value,
    });
  };

  handleStreakChange = (evt) => {
    this.setState({
      streakAdd: evt.target.value,
    });
  };

  handleStreakAddClick = () => {
    const { user } = this.props;
    if (
      user.active_child &&
      this.state.streakAdd > 0 &&
      this.state.streakAdd !== ""
    ) {
      user.requestUpdateStreakByChildId({
        child_id: user.active_child.id,
        streak: parseInt(this.state.streakAdd, 10),
      });
      this.setState({
        streakAdd: "",
      });
    }
  };

  handleAddClick = () => {
    const { user } = this.props;
    if (
      user.active_child &&
      this.state.freadoAdd >= 0 &&
      this.state.freadoAdd !== ""
    ) {
      user.requestUpdateFreadosByChildId({
        child_id: user.active_child.id,
        freadom_point: parseInt(this.state.freadoAdd, 10),
      });
      this.setState({
        freadoAdd: "",
      });
    }
  };

  handleStreakKeyDown = (evt) => {
    const { user } = this.props;
    if (
      evt.keyCode === 13 &&
      user.active_child &&
      this.state.streakAdd > 0 &&
      this.state.streakAdd !== ""
    ) {
      // this.setState({ editFreados: false });
      user.requestUpdateStreakByChildId({
        child_id: user.active_child.id,
        streak: parseInt(this.state.streakAdd, 10),
      });
    } else if (evt.keyCode === 13) {
      this.setState({ editStreak: false });
    }
  };

  handleFreadosKeyDown = (evt) => {
    const { user } = this.props;
    if (
      evt.keyCode === 13 &&
      user.active_child &&
      this.state.freadoAdd >= 0 &&
      this.state.freadoAdd !== ""
    ) {
      // this.setState({ editFreados: false });
      user.requestUpdateFreadosByChildId({
        child_id: user.active_child.id,
        freadom_point: parseInt(this.state.freadoAdd, 10),
      });
    } else if (evt.keyCode === 13) {
      this.setState({ editFreados: false });
    }
  };

  saveChangesBtn = () => {
    const { cms_id } = this.state.child_info;
    if (cms_id && !/^\d{1,11}$/.test(cms_id.trim())) {
      swal("Error!", "CMS ID must be up to 11 numeric digits!", "error");
      return;
    }
    this.setState({
      enableEdit: false,
    });
    this.props.user.requestUpdateChildProfile(this.state.child_info);
  };

  handleToggle = () => {
    const { permission } = this.props.onboard;
    if (Permission.getPermission(permission, "change_user")) {
      if (this.props.user.active_child)
        this.props.user.requestUpdateChildSubLevel({
          id: this.state.child_info.id,
          level: "Hard",
        });
    }
  };

  handleNavigationSelector = (choice) => {
    if (this.state.selected_nav !== choice)
      this.setState({
        selected_nav: choice,
      });
  };

  handleLinkSchoolCode = () => {
    this.props.ui.showModal("schoolLinkform");
  };

  handleUnlinkSchoolCode = () => {
    this.props.ui.showModal("schoolUnlinkWarning");
  };

  handleAssignFreadomTeacher = () => {
    this.props.ui.showModal("assignFreadomTeacher");
  };

  handleUnAssignFreadomTeacher = () => {
    this.props.ui.showModal("UnAssignFreadomTeacher");
  };

  removeParentSuffix(inputString) {
    // Check if the string ends with "'s parent" and remove it
    if (
      inputString.endsWith("'s parent") ||
      inputString.endsWith("'s Parent")
    ) {
      return inputString.slice(0, -9); // Remove the last 10 characters
    }
    return inputString;
  }

  render() {
    let state = this.state;
    let { user } = this.props;
    let { onboard } = this.props;
    let navList = ["Profile"];

    const { permission } = this.props.onboard;

    const teacherId = user.active_child && user.active_child.teacher;

    const freadom_teacher_sections =
      user.active_child &&
      user.active_child.school_class &&
      Array.isArray(user.active_child.school_class) &&
      user.active_child.school_class
        .filter((sc) => sc.teacher === teacherId)
        .map((sc) => sc.name)
        .join(", ");

    const wow_teacher_sections =
      user.active_child &&
      user.active_child.school_class &&
      Array.isArray(user.active_child.school_class) &&
      user.active_child.school_class
        .filter((sc) => sc.wow_teacher === teacherId)
        .map((sc) => sc.name)
        .join(", ");

    let halfYearlyFluencyTestTaken = { value: false };
    let fullYearlyFluencyTestTaken = { value: false };

    this.props.user.active_child &&
      this.props.user.active_child.fluency_test_data &&
      this.props.user.active_child.fluency_test_data.forEach((test) => {
        let submittedDate = new Date(test.submitted_date);
        let academicYearStartDate = new Date(ACADEMIC_YEAR_START);
        let academicYearEndDate = new Date(ACADEMIC_YEAR_END);

        if (
          submittedDate >= academicYearStartDate &&
          submittedDate <= academicYearEndDate &&
          (submittedDate.getMonth() === 8 || submittedDate.getMonth() === 9)
        )
          halfYearlyFluencyTestTaken = {
            value: true,
            date: test.submitted_date,
          };
        if (
          submittedDate >= academicYearStartDate &&
          submittedDate <= academicYearEndDate &&
          (submittedDate.getMonth() === 1 || submittedDate.getMonth() === 2)
        )
          fullYearlyFluencyTestTaken = {
            value: true,
            date: test.submitted_date,
          };
      });

    return (
      <ParentBodyContentContainer style={{ padding: 0 }}>
        {this.props.user.active_child ? (
          <NavigationHeaderContainer shadow style={{ paddingLeft: "30px" }}>
            <NavigationContainer>
              {navList.map((choice, i) => (
                <a
                  key={i}
                  className={choice === this.state.selected_nav ? "active" : ""}
                  onClick={() => this.handleNavigationSelector(choice)}
                >
                  <span> {choice}</span>
                </a>
              ))}
            </NavigationContainer>
          </NavigationHeaderContainer>
        ) : null}

        {this.props.user.active_child &&
          (this.state.selected_nav === "Profile" ? (
            <ChildProfileContainer>
              <ChildUploadContainer>
                <FlexBetween>
                  <ChildLabels>
                    <ChildSubHeading style={{ fontSize: "18px" }}>
                      Personal Details{" "}
                    </ChildSubHeading>
                    {!state.enableEdit &&
                      Permission.getPermission(permission, "change_user") ? (
                      <span>
                        <EditIcon onClick={this.enableEdit}>
                          <img
                            src={require("static/img/editicon.png")}
                            alt="edit-icon"
                          />
                        </EditIcon>
                      </span>
                    ) : null}
                  </ChildLabels>
                  {state.enableEdit ? (
                    <ThemeButton primary onClick={this.saveChangesBtn}>
                      SaveChanges
                    </ThemeButton>
                  ) : null}
                </FlexBetween>
                <AlignRow
                  margin={"0px 0px 12px 0px"}
                  style={{ paddingTop: "8px" }}
                >
                  <ParentFormField
                    className="col-sm-8 col-md-3 col-lg-3"
                    padding="3px 6px"
                  >
                    <input
                      type="text"
                      autoFocus
                      placeholder="Full Name"
                      value={state.child_info.name}
                      onChange={this.handleNameChange}
                      disabled={!state.enableEdit}
                    />
                  </ParentFormField>
                  <div className="col-sm-4 col-md-1 col-lg-1" />
                  <ParentFormField
                    className="col-sm-8 col-md-3 col-lg-3"
                    padding="3px 6px"
                  >
                    <input
                      type="text"
                      autoFocus
                      placeholder="School Name"
                      value={state.child_info.school}
                      onChange={this.handleSchoolChange}
                      disabled={!state.enableEdit}
                    />
                  </ParentFormField>
                  <div className="col-sm-4 col-md-1 col-lg-1" />
                  <ParentFormField
                    className="col-sm-8 col-md-3 col-lg-3"
                    padding="3px 6px"
                  >
                    <input
                      type="text"
                      autoFocus
                      placeholder="Age"
                      value={state.child_info.age}
                      onChange={this.handleAgeChange}
                      disabled={!state.enableEdit}
                    />
                  </ParentFormField>
                  <div className="col-sm-4 col-md-1 col-lg-1" />
                </AlignRow>
              </ChildUploadContainer>
              <ChildUploadContainer>
                <ChildSubHeading style={{ fontSize: "18px" }}>
                  <FlexBetween>
                    <div>Other Details </div>
                  </FlexBetween>
                </ChildSubHeading>
                <FlexBetween style={{ paddingTop: "14px", paddingBottom: "10px" }}>
                  {
                    this.props.user.active_child.parent &&
                    this.props.user.active_child.parent.is_teacher === null &&

                    <ChildFieldLabel>
                      <ParentInfo align="16px" color="#432666">
                        <b>CMS ID: </b>
                        {this.state.editCmsId ? (
                          <input
                            type="text"
                            autoFocus
                            style={{
                              width: "120px",
                              padding: "2px 6px",
                              borderRadius: "4px",
                              border: "1px solid #ccc",
                              marginLeft: "5px",
                              fontSize: "14px",
                            }}
                            value={state.child_info.cms_id || ""}
                            onChange={this.handleCmsIdChange}
                            onBlur={this.handleCmsIdBlurOrSubmit}
                            onKeyDown={this.handleCmsIdKeyDown}
                            maxLength={11}
                          />
                        ) : (
                          <React.Fragment>
                            <span>
                              {state.child_info.cms_id
                                ? state.child_info.cms_id
                                : "N/A"}
                            </span>
                            <i
                              style={{ marginLeft: "8px", cursor: "pointer", fontSize: "14px", color: "#432666" }}
                              onClick={this.toggleEditCmsId}
                              className="fa fa-pencil"
                            />
                          </React.Fragment>
                        )}
                      </ParentInfo>
                    </ChildFieldLabel>
                  }
                  <ChildFieldLabel>
                    <ChildInputField>
                      <FlexBetween start>
                        <span style={{ color: "#432666" }}>
                          <b>Freadom Points: </b>( {user.active_child.freadom_point} )
                        </span>
                      </FlexBetween>
                    </ChildInputField>
                  </ChildFieldLabel>

                  <ChildFieldLabel>
                    <ChildInputField>
                      <FlexBetween start>
                        <span style={{ color: "#432666" }}>
                          <b>Streak: </b>( {user.active_child.streak} )
                        </span>
                      </FlexBetween>
                    </ChildInputField>
                  </ChildFieldLabel>

                  <ChildFieldLabel>
                    <ParentInfo align="16px" color="#432666">
                      <b>School Code: </b>
                      {user.active_child.school_code ? (
                        <React.Fragment>
                          <span style={{ marginLeft: "4px", marginRight: "4px" }}>{user.active_child.school_code}</span>
                          <i
                            style={{ marginLeft: "5px", cursor: "pointer" }}
                            onClick={this.handleUnlinkSchoolCode}
                            className="link_icon fa fa-chain-broken"
                            title="Unlink School Code / Section"
                          />
                          {user.active_child.is_teacher && (
                            <i
                              style={{ marginLeft: "6px", cursor: "pointer" }}
                              onClick={this.handleLinkSchoolCode}
                              className="link_icon fa fa-link"
                              title="Link another Section"
                            />
                          )}
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <span style={{ marginLeft: "4px", marginRight: "4px" }}>No School code</span>
                          <i
                            style={{ marginLeft: "5px", cursor: "pointer" }}
                            onClick={this.handleLinkSchoolCode}
                            className="link_icon fa fa-link"
                          />
                        </React.Fragment>
                      )}
                    </ParentInfo>
                  </ChildFieldLabel>
                </FlexBetween>

                <FlexBetween style={{ paddingTop: "10px", paddingBottom: "10px", justifyContent: "flex-start", alignItems: "center" }}>
                  <div style={{ marginRight: "40px" }}>
                    <InterestsContainer>
                      <span> Interests : </span>
                      {this.props.user.active_child.interest &&
                        this.props.user.active_child.interest.length ? (
                        <span>
                          {this.props.user.active_child.interest.toString()}
                        </span>
                      ) : (
                        "No Interests added"
                      )}
                    </InterestsContainer>
                  </div>

                  {this.props.user.active_child &&
                    (this.props.user.active_child.is_teacher === true ||
                      String(this.props.user.active_child.is_teacher).toLowerCase().trim() === "true") &&
                    this.props.user.active_child.school_code && (
                      <ChildFieldLabel style={{ marginBottom: 0 }}>
                        <ParentInfo align="16px" color="#432666">
                          <b>Freadom Teacher: </b>
                          {freadom_teacher_sections ? (
                            <React.Fragment>
                              <span style={{ marginLeft: "4px" }}>({freadom_teacher_sections}) </span>
                              <i
                                style={{ marginLeft: "8px", cursor: "pointer" }}
                                onClick={this.handleUnAssignFreadomTeacher}
                                className="link_icon fa fa-chain-broken"
                                title="Unassign Freadom Teacher"
                              />
                              <i
                                style={{ marginLeft: "6px", cursor: "pointer" }}
                                onClick={this.handleAssignFreadomTeacher}
                                className="link_icon fa fa-link"
                                title="Assign Freadom Teacher"
                              />
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <span style={{ marginLeft: "4px", marginRight: "6px" }}>Not assigned</span>
                              <i
                                style={{ marginLeft: "5px", cursor: "pointer" }}
                                onClick={this.handleAssignFreadomTeacher}
                                className="link_icon fa fa-link"
                              />
                            </React.Fragment>
                          )}
                        </ParentInfo>
                      </ChildFieldLabel>
                    )}
                </FlexBetween>
              </ChildUploadContainer>
              <ChildUploadContainer>
                <ChildSubHeading style={{ fontSize: "18px" }}>
                  Profile Details
                </ChildSubHeading>
                <ParentDetailsContainer>
                  <ParentInfo align="16px" color="#432666">
                    {user.active_child &&
                      user.active_child.parent &&
                      user.active_child.parent.name &&
                      this.removeParentSuffix(user.active_child.parent.name)}
                  </ParentInfo>
                  <ParentInfo align="16px" color={"rgba(67,38,102,0.6)"}>
                    {user.active_child.parent.email}
                  </ParentInfo>
                  {/* {!onboard.user.read_only ? (
                    <ParentInfo align="14px" color={"rgba(67,38,102,0.6)"}>
                      Contact Number:{" "}
                      {user.active_child.parent.contact_no &&
                        user.active_child.parent.contact_no
                          .toString()
                          .substring(0, 10)}
                    </ParentInfo>
                  ) : null} */}
                  <ParentInfo align="16px" color={"rgba(67,38,102,0.6)"}>
                    {user.active_child &&
                      user.active_child.parent &&
                      user.active_child.parent.is_teacher === null
                      ? "Student"
                      : user.active_child.parent.is_teacher === true
                        ? "Teacher"
                        : "External Staff"}
                  </ParentInfo>
                </ParentDetailsContainer>
              </ChildUploadContainer>
            </ChildProfileContainer>
          ) : (
            <ChildSubscription />
          ))}
      </ParentBodyContentContainer>
    );
  }
}

export default connectStore({
  user,
  onboard,
  ui,
})(ChildProfileInfo);
